import { NavLink, Outlet } from "react-router-dom";

import { CollectionsTray } from "./CollectionsTray";

const NAV = [
  { to: "/search", label: "Search", end: false },
  { to: "/library", label: "Library", end: false },
  { to: "/themes", label: "Themes", end: false },
  { to: "/speakers", label: "Speakers", end: false },
];

/** The app shell: header, page outlet, footer and the collections tray. */
export function Layout() {
  return (
    <div className="flex min-h-screen flex-col">
      <header className="sticky top-0 z-30 border-b border-hairline bg-cream/90 backdrop-blur">
        <div className="mx-auto flex max-w-6xl flex-col gap-2 px-5 py-3 sm:flex-row sm:items-center sm:justify-between">
          <NavLink to="/" className="leading-tight">
            <span className="block whitespace-nowrap font-display text-lg text-warm-brown">
              Vihangam Yog
            </span>
            <span className="eyebrow block text-[0.6rem]">Knowledge Base</span>
          </NavLink>
          <nav className="-mx-1 flex items-center gap-1 overflow-x-auto text-sm">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `rounded-full px-3 py-1.5 transition-colors ${
                    isActive
                      ? "bg-peach/60 text-terra"
                      : "text-warm-gray hover:text-warm-brown"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main className="mx-auto w-full max-w-6xl flex-1 px-5 py-8">
        <Outlet />
      </main>

      <footer className="border-t border-hairline">
        <div className="mx-auto max-w-6xl px-5 py-6 text-sm text-warm-gray">
          A working library of the Sansthan's discourses, transcribed and
          indexed. Quotes are drawn verbatim from the transcripts, with a link
          to the moment they were spoken.
        </div>
      </footer>

      <CollectionsTray />
    </div>
  );
}
